import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const ParamsForm = ({ updateCompanies, externalCompaniesFactory }) => (
	<div>
		<Field id="helpNurse" name="helpNurse" customlabel="Activer la fonctionnalité de télésecrétariat" component={Checkbox} required />
		<Field id="checkMySecu" name="checkMySecu" customlabel="Vérification MySecu" component={Checkbox} required />
		<MultipleSelect update={updateCompanies} factory={externalCompaniesFactory} />
	</div>
);

export default ParamsForm;
